import React, {
    PropTypes,
} from 'react';
import {ButtonToolbar, Dropdown, Glyphicon, MenuItem} from 'react-bootstrap';

class CustomSelect extends React.Component {
    static propTypes = {
        choices: PropTypes.array.isRequired,
        current: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        emptyValue: PropTypes.string.isRequired,
        valueKey: PropTypes.string.isRequired,
        className: PropTypes.string.isRequired,
        onChange: PropTypes.func.isRequired,
        avatar: PropTypes.func,
        pic: PropTypes.string.isRequired,
        idKey: PropTypes.string.isRequired,
        onToggle: PropTypes.func,
    };

    onSelect(key) {
        this.props.onChange(key);
    }

    render() {
        const {choices, valueKey, current, emptyValue, pic, className, avatar, idKey, onToggle} = this.props;
        let name = null;
        const usersList = choices.map(
            (choice, id) => {
                if (choice[idKey] === current) {
                    name = choice[valueKey];
                }
                return (
                    <MenuItem eventKey={id}
                              key={id}>{avatar ? avatar(choice) : ''}{choice[valueKey]}</MenuItem>
                );
            }
        );
        const onTogg = onToggle || ((open) => {
            });

        return (
            <ButtonToolbar className={className + ' ml0'}>
                <Dropdown id="user-selector" onToggle={onTogg} onSelect={this.onSelect.bind(this)} block
                          style={{marginLeft: 0}}>
                    <Dropdown.Toggle bsStyle="success" block>
                        <Glyphicon glyph={pic}/>&nbsp;
                        {name ? name : emptyValue}
                    </Dropdown.Toggle>
                    <Dropdown.Menu className="col-xs-12">
                        {usersList}
                    </Dropdown.Menu>
                </Dropdown>
            </ButtonToolbar>
        );
    }
}

export default CustomSelect;



/** WEBPACK FOOTER **
 ** ./src/components/CustomSelect.js
 **/